<template>
  <div>
    <headerTop></headerTop>
    <div class="wrapper">
      <!-- 极配正品 -->
      <!-- <div class="header">
        <img src="@/assets/images/home/logo.png" class="logo" alt="" />
        <div style="position: relative;">
          <div style=" position: absolute;bottom: 0;right: 0; width: 135px;">
            正见 &nbsp; •&nbsp;&nbsp;正心&nbsp; •&nbsp;&nbsp;正品
          </div>
        </div>
      </div> -->
      <div class="content_button">
        <!-- 进度 -->
        <div class="flow ">
          <div class="flowcontent">
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-zu5361"></i> -->
                <img src="@/assets/images/refund/组 1615.png" alt="" />
              </div>
              <div>卖家发起退款</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1613.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan38"></i> -->
                <img src="@/assets/images/refund/组 1612.png" alt="" />
              </div>
              <div class="finish">退款完毕</div>
            </div>
            <!-- <div>
              <div></div>
              <div>买家申请退货退款</div>
            </div>
            <img src="@/assets/images/orderDetails/success.png" alt="" />
            <div>
              <div></div>
              <div>买家申请退货退款</div>
            </div>
            <img src="@/assets/images/orderDetails/success.png" alt="" /> -->
          </div>
        </div>
        <div class="tk">
          <!-- 详情 -->
          <div class="testimony">
            <!-- 退款 -->
            <div class="dispose">
              <div class="tytk">
                <span class="iconfont icon-tongyihuanhuo"></span>
              </div>
              <p>
                卖家已退款,退款金额
                <span>&yen;{{ refundindent.goodsAmount }}</span>
              </p>
            </div>
            <!-- 表单 -->
            <div class="Sheets">
              <Row>
                <Col span="5">
                  <span>服务类型 :</span>
                  <!-- <span>{{}}</span> -->
                  <span style="margin-left:5px">{{
                    information.type == 1 ? '退款' : '退货退款'
                  }}</span>
                </Col>
                <Col span="12">
                  <span>原因 :</span>
                  <span style="margin-left:5px">{{ information.content }}</span>
                </Col>
              </Row>
              <div class="explain">
                <div class="w64">退款说明 :</div>
                <div class="smcontent">
                  <span style="margin-left: 5px">{{ information.remark }}</span>
                </div>
              </div>
              <Row>
                <Col style="margin-top:8px">
                  <div style=" display: flex;">
                    <div>上传凭证 :</div>
                    <ul>
                      <li v-viewer>
                        <img
                          v-for="item in voucherlist"
                          :key="item"
                          :src="item"
                          alt=""
                        />
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
            <!-- 表格 -->
            <div class="sheet">
              <span class="returns"> 退款商品:</span>
              <vxe-table
                border
                ref="xTable3"
                size="mini"
                align="center"
                resizable
                show-overflow
                :data="tableData3"
              >
                <vxe-column
                  field="partName"
                  title="退款商品"
                  width="220"
                ></vxe-column>
                <vxe-column
                  field="partNum"
                  title="购买数量"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="refundableAmount"
                  title="可退数量"
                  width="100"
                ></vxe-column>
                <vxe-column field="refundNumber" title="退款数量" width="120">
                </vxe-column>
                <vxe-column
                  field="price"
                  title="退款单价"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="moneybackPrice"
                  title="退款金额"
                  width="100"
                ></vxe-column>
              </vxe-table>
            </div>
          </div>

          <!-- 订单详情 -->
          <div class="indentparticulars">
            <div class="headline">
              <span>订单详情</span>
            </div>
            <div class="content">
              <div class="content_top">
                <Row>
                  <Col span="6">
                    <span>卖家: &nbsp;</span>
                    <span>{{ particulars.buyShopName }}</span>
                    <span v-if="information.role == 1">
                      <xiaopei
                        :oppositeTenantId="particulars.buyTenantId"
                        :orderId="information.afterSaleId"
                      >
                        <i class="iconfont icon-a-lujing162"></i> </xiaopei
                    ></span>
                  </Col>
                  <Col span="6">
                    <span>订单编号 :&nbsp;</span>
                    <span class="span1">
                      <router-link
                        rel="opener"
                        :to="{
                          path: '/orderDetails',
                          query: {
                            id: particulars.code,
                            orderId: particulars.id
                          }
                        }"
                        >{{ particulars.code }}</router-link
                      >
                    </span>
                  </Col>
                  <Col span="6">
                    <span>商品金额 :&nbsp;</span>
                    <span style="margin-left:5px;"
                      >&yen;{{ particulars.goodsAmount }}</span
                    >
                  </Col>
                </Row>

                <div style="margin-top:40px">
                  <Row>
                    <Col span="6">
                      <span>运费 :&nbsp;</span>
                      <span style="margin-left:5px;"
                        >&yen;{{
                          particulars.freight ? particulars.freight : 0
                        }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>实付款: &nbsp;</span>
                      <span style="margin-left:5px;"
                        >&yen;{{ particulars.payMoney }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>数量 :&nbsp;</span>
                      <span style="margin-left:5px;">{{
                        particulars.count
                      }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
              <div class="details">
                <div class="cleared">
                  <Row>
                    <Col span="6">
                      <span>退款单号 :&nbsp;</span>
                      <span style="margin-left:5px;">{{
                        refundindent.code
                      }}</span>
                    </Col>
                    <Col span="6">
                      <span>服务类型 :&nbsp;</span>
                      <span style="margin-left:5px;">{{
                        refundindent.type == '1' ? '退款' : '退货退款'
                      }}</span>
                    </Col>
                    <Col span="6">
                      <span>退款金额 :&nbsp;</span>
                      <span style="margin-left:5px;"
                        >&yen;{{ refundindent.goodsAmount }}</span
                      >
                    </Col>
                  </Row>
                  <Row style="margin-top:33px">
                    <Col span="6">
                      <span>状态 :&nbsp;</span>
                      <span class="colorFF6">{{ information.orderState }}</span>
                    </Col>
                    <Col span="6">
                      <span>退款数量 :&nbsp;</span>
                      <span>{{ refundindent.count }}</span>
                    </Col>
                    <Col span="6">
                      <span>原因 :&nbsp;</span>
                      <span>{{ information.content }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 80px;"></div>
  </div>
</template>

<script>
import headerTop from '@/views/base/common/header-top.vue'
import { disposeInfo } from '@/api/refund/index'
import xiaopei from '@/views/xiaopei/index.vue'
export default {
  components: {
    headerTop,
    xiaopei
  },
  props: {
    afterSaleId: String
    // finish: String
  },
  data() {
    return {
      examine: false,
      sellerconsent: true, // 卖家同意
      sellerrefuse: false, // 卖家拒绝
      // 第二个表格数据
      tableData3: [
        // {
        //   id: 10001,
        //   partsName: '奔驰水箱散热器A1695001803', // 配件名称
        //   buyquantity: '购买数量', // 购买数量
        //   returnable: '可退数量', // 可退数量
        //   returns: '退货数量', // 退货数量
        //   returnsprice: '退货单价', // 退货单价
        //   returnsmoney: '退货金额' // 退货金额
        // }
      ],
      voucherlist: [
        // {
        //   id: '1',
        //   logo:
        //     'https://img2.baidu.com/it/u=349145238,254936008&fm=253&fmt=auto&app=138&f=JPEG?w=640&h=400'
        // },
        // {
        //   id: '2',
        //   logo:
        //     'https://img2.baidu.com/it/u=349145238,254936008&fm=253&fmt=auto&app=138&f=JPEG?w=640&h=400'
        // }
      ], // 长传凭证的照片
      refundindent: {}, // 退款订单
      information: {}, // 原因
      particulars: {}, // 订单详情普通订单
      dt: ''
    }
  },
  created() {
    this.orderdata3()
  },
  methods: {
    // 退货退款详情
    async orderdata3() {
      console.log('---orderData:', this.afterSaleId)
      const res = await disposeInfo(this.afterSaleId+'/1')
      console.log(res)
      this.information = res.data
      this.voucherlist = res.data.imagesUrl
      this.tableData3 = res.data.ordersDetailVOList
      this.refundindent = res.data.refundOrderVO
      this.particulars = res.data.orderVO
      let path = this.$router.history.current.path
      this.$router.push({ path, query: { drawback: this.afterSaleId } })
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
